// extracted by mini-css-extract-plugin
export default {"validationErrors":"MessageProfile_validationErrors__hzsQr","alertBox":"MessageProfile_alertBox__+0CBU","dangerAlert":"MessageProfile_dangerAlert__Y7EqV"};